module.exports = "/fonts/vendor/material-icons/iconmaterial-icons.woff2?53436aca8627a49f4deaaa44dc9e3c05";